import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { logErrorAndRunFail, paramCheckErrno } from '../../utils';
import { ApiErrno, errnoCategory1, errnoCategory2, errorType } from 'src/shared/errno';
import { GeneralInvokeOption } from 'src/types';
export interface SetClipboardDataOption extends Partial<GeneralInvokeOption> {
  data: string;
  invalidParamObj?: '';
}

// 设置系统剪贴板内容
export function setClipboardData(option: SetClipboardDataOption) {
  if (!option.data) {
    return logErrorAndRunFail(
      APINames.Native.SET_CLIPBOARD_DATA,
      option,
      `parameter error: parameter.data is necessary, please check input param.`,
      ApiErrno.Errno(errnoCategory1.COMMON, errnoCategory2.COMMON, errorType.MISSING_PARAM)
    );
  }
  if (
    paramCheckErrno(APINames.Native.SET_CLIPBOARD_DATA, option, {
      data: ''
    })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.SET_CLIPBOARD_DATA,
      option
    );
  }
  return option.invalidParamObj;
}
